interface Props {
  className?: string;
}

export const TimeIcon = ({ className }: Props) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="7" stroke="#A4A4B6" strokeWidth="2" />
    <path
      d="M10 10L8.81773 9.13353C8.30371 8.7568 8 8.15767 8 7.52038V4"
      stroke="#A4A4B6"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const ProhibitIcon = ({ className }: Props) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1422 10C18.1422 14.4183 14.5604 18 10.1422 18C5.72387 18 2.14215 14.4183 2.14215 10C2.14215 5.58177 5.72387 2.00005 10.1422 2.00005C14.5604 2.00005 18.1422 5.58177 18.1422 10ZM20.1422 10C20.1422 15.5229 15.665 20 10.1422 20C4.6193 20 0.142151 15.5229 0.142151 10C0.142151 4.4772 4.6193 4.56695e-05 10.1422 4.57116e-05C15.665 4.55431e-05 20.1422 4.4772 20.1422 10ZM14.7417 5.19933C14.3512 4.80881 13.7181 4.80881 13.3275 5.19933L5.49903 13.0278C5.1085 13.4184 5.1085 14.0515 5.49903 14.4421C5.88955 14.8326 6.52272 14.8326 6.91324 14.4421L14.7417 6.61354C15.1323 6.22302 15.1323 5.58986 14.7417 5.19933Z"
      fill="#CECEDB"
    />
  </svg>
);

export const SucIcon = ({ className }: Props) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM14.2071 8.20711C14.5976 7.81658 14.5976 7.18342 14.2071 6.79289C13.8166 6.40237 13.1834 6.40237 12.7929 6.79289L8.65541 10.9304L7.33203 8.9453C7.02568 8.48577 6.40481 8.3616 5.94528 8.66795C5.48576 8.9743 5.36158 9.59517 5.66793 10.0547L7.4142 12.6741C7.89551 13.3961 8.91699 13.4972 9.53054 12.8837L14.2071 8.20711Z"
      fill="#2FB773"
    />
  </svg>
);
